var map = {
	"./PUGLIASALUTE_bottom.jpg": 991,
	"./PUGLIASALUTE_top.jpg": 701,
	"./SISOS_top.jpg": 970,
	"./background.jpg": 671,
	"./desktop.jpg": 179,
	"./promedital-logo-full.jpg": 416,
	"./settings_background.jpg": 513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 760;